import React from 'react';
import { useTranslation } from "react-i18next";
import {
    Box,
    styled,
    Typography,
} from "@mui/material";
import { DeleteForeverOutlined } from '@mui/icons-material';
const DeleteForeverOutlinedHover = styled(DeleteForeverOutlined)(({ theme }) => ({
    '&:hover': {
        color: "white"
    },
}));
const OrderItem = ({ item, handleRemove, deletable }) => {
    const { t } = useTranslation();
    return !!item ?
        <Box sx={{ borderRadius: '3px', my: 1, display: "flex", width: '100%' }} style={{ backgroundColor: "#E0E0E0" }}>
            <Box mx={{ xs: 1, sm: 2, md: 4 }} mb={1} sx={{ display: "flex", flexDirection: 'column', flex: 1 }}>
                <Typography sx={{ fontSize: 13, }}>{t("Description") + ":"}</Typography>
                <Typography mt={-0.7} sx={{ fontSize: 16, fontWeight: 'bold', maxWidth: {xs: 232, sm: 210, md: 170}, wordWrap: "break-word", overflowWrap: "break-word" }}>{item.item}</Typography>
            </Box>
            <Box mx={{ xs: 1, sm: 2, md: 4 }} mb={1} sx={{ display: "flex", flexDirection: 'column' }}>
                <Typography sx={{ fontSize: 13, }}>{t("Count") + ":"}</Typography>
                <Typography mt={-0.7} sx={{ fontSize: 16, fontWeight: 'bold' }}>{item.amount}</Typography>
            </Box>
            {
                deletable &&
                <Box mx={{ xs: 1, sm: 2, md: 4 }} mb={1} sx={{ display: "flex", flexDirection: 'column', justifyContent: "center", cursor: "pointer" }}>
                    <DeleteForeverOutlinedHover onClick={_ => handleRemove(item._id)} />
                </Box>
            }
        </Box>
        :
        <></>
}

export default OrderItem;